<template>
  <span class="sort-by">
    <span class="sort-by__label">Sort by:</span>
    <span
      :class="sortBtnClasses(SORT_TYPE.LATEST)"
      @click="setActiveSorting(SORT_TYPE.LATEST)"
    >
      {{ SORT_TYPE_NAME[SORT_TYPE.LATEST] }}
    </span>
    <span class="sort-by__delimiter">|</span>
    <span
      :class="sortBtnClasses(SORT_TYPE.OLDEST)"
      @click="setActiveSorting(SORT_TYPE.OLDEST)"
    >
      {{ SORT_TYPE_NAME[SORT_TYPE.OLDEST] }}
    </span>
  </span>
</template>

<script>
export const SORT_TYPE = {
  LATEST: 'Desc',
  OLDEST: 'Asc'
}

export const SORT_TYPE_NAME = {
  [SORT_TYPE.LATEST]: 'Latest',
  [SORT_TYPE.OLDEST]: 'Oldest'
}

export default {
  name: 'ASortByLatestOldest',
  data() {
    return {
      SORT_TYPE,
      SORT_TYPE_NAME,
      activeSorting: SORT_TYPE.LATEST
    }
  },
  methods: {
    setActiveSorting(sorting) {
      this.activeSorting = sorting
      this.$emit('input', sorting)
    },
    sortBtnClasses(sorting) {
      return [
        'sort-by__btn',
        { 'sort-by__btn--active': this.activeSorting === sorting }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-by {
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;

  & * {
  }

  @include mobile {
    font-size: 12px;
    line-height: 26px;
    padding-left: 10px;
  }
}

.sort-by__label {
  margin-right: 10px;

  @include mobile {
    margin-right: 5px;
  }
}

.sort-by__delimiter {
  margin: 0 10px;

  @include mobile {
    margin: 0 5px;
  }
}

.sort-by__btn {
  cursor: pointer;
  font-weight: 600;
}

.sort-by__btn--active {
  color: $c--main;
}
</style>
